import { SharedAngular } from '@Client/@types/sharedAngular';
import { PdfHelper } from '@Client/runner.flow/runner.flow/runner.flow.service';
import angular, { ILocationService, ITimeoutService } from 'angular';

class RunnerPrintFlowController {
  public static $inject = [
    'PPDFService',
    '$timeout',
    'runnerFlowsFormatter',
    'flowApiService',
    '$location',

    '$q',
    'sessionService',
    'avatarService',
    'dateService',
    'APP_CONFIG',
    '$http',
    'lodashService',
    '$sce',
    'flowinglyConstants',
    'runnerFlowService',
    'commentApiService',
    'fileService'
  ];

  constructor(
    private PPDFService: PPDFService,
    private $timeout: ITimeoutService,
    private runnerFlowsFormatter: RunnerFlowsFormatterService,
    private flowApiService: FlowApiService,
    private $location: ILocationService,

    private $q,
    private sessionService,
    private avatarService,
    private dateService,
    private APP_CONFIG,
    private $http,
    private lodashService,
    private $sce,
    private flowinglyConstants,
    private runnerFlowService: RunnerFlowService,
    private commentApiService: SharedAngular.CommentApiService,
    private fileService: SharedAngular.FileService
  ) {
    const flowId = this.$location.search().id;
    const userTimeZone = this.$location.search().timezone;
    this.flowApiService.getFlowById(flowId, false).then((flowForUser) => {
      const formattedFlow = this.runnerFlowsFormatter.formatFlow(
        flowForUser,
        userTimeZone
      );
      return PdfHelper.generatePdfPayload(
        formattedFlow as any,
        this as any
      ).then((data) => {
        return this.PPDFService.generatePpdfInCurrentWindow(
          'Client/runner/services/pdf-templates/flow-to-ppdf.html',
          data
        );
      });
    });
  }
}
angular
  .module('flowingly.runner.print')
  .controller('runnerPrintFlowController', RunnerPrintFlowController);
